import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faArrowLeft,
  faTimes,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";
import academic from "../../assets/images/Reviews/academics.png";
import club from "../../assets/images/Reviews/club.png";
import dollar from "../../assets/images/Reviews/dollar.png";
import entranceIcon from "../../assets/images/Reviews/entrance.png";
import placement from "../../assets/images/Reviews/placement.png";
import { useNavigate } from "react-router-dom";
import DetailIcon from "../../assets/images/Reviews/detailed.png";

const DetailedReviewView = ({ reviewData }) => {
  const [activeTab, setActiveTab] = useState("basic");
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [popupImageSrc, setPopupImageSrc] = useState("");

  console.log(reviewData);

  // Safe data access with fallbacks
  const safeData = reviewData || {};
  const {
    college_id = "N/A",
    clg_name = "N/A",
    clg_logo = "",
    year_of_admission = "N/A",
    name = "N/A",
    email = "N/A",
    phone_number = "N/A",
    go_anonymous = "0",
    subjective_data = [],
    objective_data = [], // Add this line to get objective data
    ratings = 0,
    review_title = "Detailed Review",
  } = safeData;

  const navigate = useNavigate();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Image popup handlers
  const openImagePopup = (imageSrc) => {
    setPopupImageSrc(imageSrc);
    setShowImagePopup(true);
  };

  const closeImagePopup = () => {
    setShowImagePopup(false);
    setPopupImageSrc("");
  };

  // Helper function to render star ratings
  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <FontAwesomeIcon
          key={i}
          icon={faStar}
          className={i < rating ? "vsr-star-filled" : "vsr-star-empty"}
        />
      );
    }
    return stars;
  };

  // Helper function to format category names for display
  const formatCategoryName = (category) => {
    return category
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Render the college logo or university icon if no logo
  const renderCollegeLogo = (size = "normal") => {
    let style;

    if (size === "small") {
      style = {
        width: "30px",
        height: "30px",
        marginRight: "10px",
        objectFit: "contain",
      };
    } else if (size === "lg") {
      style = {
        width: "60px",
        height: "60px",
        marginRight: "15px",
        objectFit: "contain",
      };
    } else {
      style = {
        width: "50px",
        height: "50px",
        marginRight: "15px",
        objectFit: "contain",
      };
    }

    if (clg_logo && typeof clg_logo === "string" && clg_logo.trim() !== "") {
      return (
        <img
          src={clg_logo}
          alt={`${clg_name} logo`}
          style={style}
          className="br-college-logo"
        />
      );
    } else {
      return (
        <div className="br-college-logo-icon" style={style}>
          <FontAwesomeIcon
            icon={faUniversity}
            size={size === "small" ? "lg" : size === "lg" ? "3x" : "2x"}
          />
        </div>
      );
    }
  };

  // Category icons mapping with imported images
  const getCategoryIcon = (category) => {
    const icons = {
      entrance_exams_and_admissions: entranceIcon,
      fees_and_scholarships: dollar,
      academics_and_faculty: academic,
      placements_and_internships: placement,
      clubs_and_activities: club,
      clubs_and_associations: club, // Added this to match your API data
      default: academic, // Fallback to academic icon
    };

    return icons[category] || icons.default;
  };

  return (
    <div className="vsr-container">
      {/* Image Popup */}
      {showImagePopup && (
        <div className="vsr-image-popup-overlay" onClick={closeImagePopup}>
          <div
            className="vsr-image-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="vsr-image-popup-close" onClick={closeImagePopup}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <img
              src={popupImageSrc}
              alt="Full size view"
              className="vsr-image-popup-img"
              onError={(e) => {
                e.target.src = "/placeholder-image.jpg";
              }}
            />
          </div>
        </div>
      )}

      {/* Page Header */}
      <div className="vsr-header">
        <button className="vsr-back-button" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <div className="srtIcon">
          <img className="srt-img" src={DetailIcon} alt="short" />
          <h2 className="srv-page-title">Detailed Review</h2>
        </div>
      </div>

      {/* Review Card */}
      <div className="vsr-card">
        <div
          className="br-reviewer-header"
          style={{ display: "flex", alignItems: "center" }}
        >
          {renderCollegeLogo("lg")}
          <h3 className="br-college-name">{clg_name}</h3>
        </div>

        {/* Tabs Navigation */}
        <div className="vsr-tabs-container">
          <div className="vsr-tabs-header">
            <button
              className={`vsr-tab-button ${
                activeTab === "basic" ? "active" : ""
              }`}
              onClick={() => handleTabChange("basic")}
            >
              Basic Info
            </button>
            <button
              className={`vsr-tab-button ${
                activeTab === "subjective" ? "active" : ""
              }`}
              onClick={() => handleTabChange("subjective")}
            >
              Subjective
            </button>
            <button
              className={`vsr-tab-button ${
                activeTab === "objective" ? "active" : ""
              }`}
              onClick={() => handleTabChange("objective")}
            >
              Objective
            </button>
          </div>

          <div className="vsr-tab-content">
            {activeTab === "basic" && (
              <div className="vsr-basic-tab">
                <h4>Basic Information</h4>
                <div className="vsr-details-grid">
                  <div className="vsr-detail-item">
                    <span className="vsr-detail-label">College/University</span>
                    <span className="vsr-detail-value">{clg_name}</span>
                  </div>
                  <div className="vsr-detail-item">
                    <span className="vsr-detail-label">Year of Admission</span>
                    <span className="vsr-detail-value">
                      {year_of_admission}
                    </span>
                  </div>
                  <div className="vsr-detail-item">
                    <span className="vsr-detail-label">Your Name</span>
                    <span className="vsr-detail-value">
                      {go_anonymous === "1" ? "Anonymous" : name}
                    </span>
                  </div>
                  <div className="vsr-detail-item">
                    <span className="vsr-detail-label">Email ID</span>
                    <span className="vsr-detail-value">{email}</span>
                  </div>
                  <div className="vsr-detail-item">
                    <span className="vsr-detail-label">Phone Number</span>
                    <span className="vsr-detail-value">{phone_number}</span>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "subjective" && (
              <div className="vsr-subjective-tab">
                <h4>Subjective Reviews</h4>
                {subjective_data.map((item, index) => (
                  <div
                    key={item.detailedReviewId || index}
                    className="vsr-subjective-item"
                  >
                    <div className="vsr-subjective-header">
                      <div className="vsr-category-header">
                        <div className="vsr-category-icon">
                          <img
                            src={getCategoryIcon(item.subjective_review_type)}
                            alt={formatCategoryName(
                              item.subjective_review_type
                            )}
                            className="category-icon-image"
                            width="auto"
                            height="30"
                          />
                        </div>
                        <h5 className="vsr-category-title">
                          {formatCategoryName(item.subjective_review_type)}
                        </h5>
                      </div>
                      <div className="vsr-rating-display">
                        {renderStars(item.ratings)}
                        <span className="vsr-rating-value">
                          {item.ratings.toFixed(1)}
                        </span>
                      </div>
                    </div>
                    <div className="vsr-subjective-content">
                      <div className="vsr-detail-review-section">
                        <div className="vsr-detail-review-label">
                          Detail Review
                        </div>
                        <div className="vsr-detail-review-content">
                          <p>{item.detailed_review}</p>
                        </div>
                      </div>

                      {item.upload_picture && (
                        <div className="vsr-photo-section">
                          <div className="vsr-photo-label">Upload Photo</div>
                          <div
                            className="vsr-photo-display"
                            onClick={() => openImagePopup(item.upload_picture)}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={item.upload_picture}
                              alt={`Review for ${item.subjective_review_type}`}
                              onError={(e) => {
                                e.target.src = "/placeholder-image.jpg";
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "objective" && (
              <div className="vsr-objective-tab">
                <h4>Objective Questions</h4>
                <div className="vsr-objective-questions">
                  {/* Map through actual objective data from API */}
                  {objective_data && objective_data.length > 0 ? (
                    objective_data.map((item, index) => (
                      <div
                        key={item.id}
                        className="vsr-objective-question-item"
                      >
                        <div className="vsr-question-text">
                          <span className="vsr-question-number">
                            {index + 1}.
                          </span>
                          <span>{item.question}</span>
                        </div>
                        <div className="vsr-answer">
                          <span className="vsr-answer-label">Answer : </span>
                          <span className="vsr-answer-text">
                            {item.option_name}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="vsr-no-data">
                      No objective review data available
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedReviewView;
